import { render, staticRenderFns } from "./gen2.vue?vue&type=template&id=7dd9d421&scoped=true"
import script from "./gen2.vue?vue&type=script&lang=js"
export * from "./gen2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd9d421",
  null
  
)

export default component.exports